export const OPEN_FAN_KEY = 'job-result-exclusion-applicant';

const store = {
	namespaced: true,
	state: {
		show: false,
		jobProfileId: undefined,
		jobId: undefined,
		applicant: undefined,
		permissionJobProfile: undefined,
		permissionComprehensive: undefined,
		onExclude: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setJobProfileId', data.jobProfileId);
			commit('setJobId', data.jobId);
			commit('setApplicant', data.applicant);
			commit('setPermissionJobProfile', data.permissionJobProfile);
			commit('setPermissionComprehensive', data.permissionComprehensive);
			commit('setOnExclude', data.onExclude);

			commit('setShow', true);
		},
		close ({commit, state}, data)
		{
			commit('setShow', false);

			if (data.saved && state.onExclude)
			{
				state.onExclude({
					exclusionType: data.exclusionType,
				});
			}

			commit('setJobProfileId', undefined);
			commit('setJobId', undefined);
			commit('setApplicant', undefined);
			commit('setPermissionJobProfile', undefined);
			commit('setPermissionComprehensive', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setJobProfileId: (state, value) => state.jobProfileId = value,
		setJobId: (state, value) => state.jobId = value,
		setApplicant: (state, value) => state.applicant = value,
		setPermissionJobProfile: (state, value) => state.permissionJobProfile = value,
		setPermissionComprehensive: (state, value) => state.permissionComprehensive = value,
		setOnExclude: (state, value) => state.onExclude = value,
	},
};

export default store;
